import React, { useEffect, useState } from "react";
import PolicyClasses from "./index.module.css";
import Layout from "Components/Layout";
import { Helmet } from "react-helmet";
import { Services } from "Services";
import SkeletonLoad from "Components/TableLoad/load";
import { Error, Error_Dark } from "Util/Toast";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { FaRegEdit, FaHistory } from "react-icons/fa";
import { AccessControl } from "Util/AccessControl";
import { AccessKeys } from "Routes/config";

const POLICY_TYPES = [
    { PolicyType: "Privacy_Policy", Label: "Privacy Policy" },
    { PolicyType: "Terms_and_Conditions", Label: "Terms and Conditions" },
    { PolicyType: "Refund_Policy", Label: "Refund Policy" },
];

function Policy() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const Navigate = useNavigate();

    const getAllPolicies = () => {
        setLoading(true);
        Services.getPolicyList("GET", null, token)
            .then((response) => {
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setData(response.PolicyPages || []);
                } else if (response.Status === 0) {
                    Error(response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                Error_Dark("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        getAllPolicies();
        // eslint-disable-next-line
    }, []);

    const rows = POLICY_TYPES.map((type) => {
        const existing = data.find(
            (item) => item.PolicyType === type.PolicyType
        );
        return { ...type, ...existing };
    });

    const editHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let type = e.currentTarget.getAttribute("id");
        Navigate(`/Policy/${type}`);
    };

    const historyHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let type = e.currentTarget.getAttribute("id");
        Navigate(`/Policy/history/${type}`);
    };

    return (
        <Layout Active={"Policy"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Policy Pages</title>
            </Helmet>
            <div className={PolicyClasses["Container"]}>
                <div className={PolicyClasses["Tutor"]}>
                    <h3>Policy Pages</h3>
                    {loading ? (
                        <SkeletonLoad
                            TableHead={[
                                "Policy",
                                "Status",
                                "Updated On",
                                "Actions",
                            ]}
                        />
                    ) : (
                        <div className={PolicyClasses["Table"]}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Policy</th>
                                        <th>Status</th>
                                        <th>Updated On</th>
                                        {AccessControl(AccessKeys.Policy)
                                            ?.read === 1 && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((item) => (
                                        <tr key={item.PolicyType}>
                                            <td>{item.Label}</td>
                                            <td
                                                className={
                                                    PolicyClasses[
                                                        "Status-active"
                                                    ]
                                                }>
                                                <span>Published</span>
                                            </td>
                                            <td>
                                                {item.UpdatedAt ? (
                                                    <Moment format="DD-MM-YYYY">
                                                        {new Date(
                                                            item.UpdatedAt
                                                        )}
                                                    </Moment>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            {AccessControl(AccessKeys.Policy)
                                                ?.read === 1 && (
                                                <td>
                                                    <div
                                                        className={
                                                            PolicyClasses[
                                                                "Action-btns"
                                                            ]
                                                        }>
                                                        {AccessControl(
                                                            AccessKeys.Policy
                                                        )?.edit === 1 && (
                                                            <button
                                                                id={
                                                                    item.PolicyType
                                                                }
                                                                onClick={
                                                                    editHandler
                                                                }
                                                                title="Edit">
                                                                <FaRegEdit />
                                                            </button>
                                                        )}
                                                        <button
                                                            id={
                                                                item.PolicyType
                                                            }
                                                            onClick={
                                                                historyHandler
                                                            }
                                                            title="View History">
                                                            <FaHistory />
                                                        </button>
                                                    </div>
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Policy;
